import {useMemo} from 'react';
import {useStoredState} from '../../../shared/hooks/useStoredState';

export enum SortableColumn {
	ProjectIndicator = 'project-indicator',
	ProjectName = 'project-name',
	TaskName = 'task-name',
	Phase = 'phase',
	Client = 'client',
	Star = 'star',
}

export type TimesheetColumnSort = {
	value: SortableColumn;
	setValue: (value: SortableColumn) => void;
	ascending: boolean;
	setAscending: (ascending: boolean) => void;
};

const VALUE_STORAGE_KEY = 'time-page-sort';
const ASCENDING_STORAGE_KEY = 'time-page-sort-ascending';

export function usePersistentTimesheetColumnSort(): TimesheetColumnSort {
	const [value, setValue] = useStoredState<SortableColumn>(VALUE_STORAGE_KEY, SortableColumn.ProjectIndicator);
	const [ascending, setAscending] = useStoredState<boolean>(ASCENDING_STORAGE_KEY, true);

	return useMemo(
		() => ({
			value,
			setValue,
			ascending,
			setAscending,
		}),
		[value, ascending, setValue, setAscending]
	);
}
